<!-- 任务列表多源或多目标，源或目标信息展开列表弹窗 -->
<template>
    <div class="popup" v-cloak v-show="isShow">
        <div class="content" id="taskMultiSources">
            <div class="title">
                
                <span v-if="type==2">{{$t('language.common.target')+"("+sources.length+")"}}</span>
                <span v-else>{{'Source('+sources.length+')'}}</span>
                
                <div class="icon white-close dialog-close" @click="closePage()"></div>
            </div>
            <div class="multi-sources-body">
                <ul style="overflow:auto">
                    <li v-for="(source,index) in sources" :key="index" @click.stop="toCatalog(source)">
                        <div class="clouds_logo clouds_logo_22" :class="source.driveType"></div>
                        <div class="multi-source-path" :title="getCatalog(source.nodes)|getCatalogTitle">
                            {{getCatalog(source.nodes)}}
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "taskMultiSources",
    // props: ["sources"],
    components: {
    },
    data: function () {
        return {
            isShow: false,
            sources: [],
            type: 1,//信息类型： 1：源，2：目标
            taskType: 0,//任务类型，参考task_list_filters
        }
    },
    methods: {
        getCatalog(nodesArr) {
            let catelog;
            if (nodesArr && nodesArr.length >= 2 &&nodesArr[0].fileId  && nodesArr[0].fileId == nodesArr[1].fileId) {
                nodesArr.splice(0, 1);
            }
            if (nodesArr) {
                let cloudItem = nodesArr[nodesArr.length - 1];
                if(cloudItem.tokenId) {
                    // 如果有云盘id，则去获取云盘名称
                    var drives = this.$store.getters.getUsersDrives;
                    for (var i=0; i<drives.length; i++) {
                        if (drives[i].id == cloudItem.tokenId) {
                            catelog = drives[i].name;
                            break;
                        }
                    }
                }else {
                    if (nodesArr[i].fileName) {
                        catelog = nodesArr[i].fileName;
                    } else if(nodesArr[i].filename){
                        catelog = nodesArr[i].filename;
                    }else{
                        catelog = nodesArr[i].name;
                    }
                }
                for (let i = nodesArr.length - 2; i >= 0; i--) {
                    if (catelog) {
                        if (nodesArr[i].fileName) {
                            catelog = catelog + '\\' + nodesArr[i].fileName;
                        } else if(nodesArr[i].filename){
                            catelog = catelog + '\\' + nodesArr[i].filename;
                        }else{
                            catelog = catelog + '\\' + nodesArr[i].name;
                        }
                    } else {
                        if (nodesArr[i].fileName) {
                            catelog = nodesArr[i].fileName;
                        } else if(nodesArr[i].filename){
                            catelog = nodesArr[i].filename;
                        }else{
                            catelog = nodesArr[i].name;
                        }
                    }
                }
            }
            return catelog;
        },
        initDate(sources,type,taskType) {
            this.sources = sources;
            console.log(sources)
            this.type = type;
            this.taskType = taskType;
            this.isShow = true;
        },
        closePage() {
            this.sources = [];
            this.type = 1;
            this.taskType = 0;
            this.isShow = false;
        },
        toCatalog(source) {
            console.log(source)
            console.log(this.type)
            if(this.type==1) {
                this.$emit("to-source-catalog",source,this.taskType);
            }else if(this.type==2) {
                this.$emit("to-aim-catalog",source,this.taskType);
            }
        }
    }
}
</script>

<style scoped>
#taskMultiSources {
    width: 600px;
    /*no*/
    height: 460px;
    /*no*/
}

.multi-sources-body {
    width: 100%;
    height: calc(100% - 60px);
    /*no*/
}

ul {
    height: 100%;
    margin: 10px 1px;
    /*no*/
    padding: 0;
}

li {
    margin-left: 15px;
    /*no*/
    height: 40px;
    /*no*/
    display: flex;
    justify-content: left;
    align-items: center;
    color: #3D3D3D;
}

li .multi-source-path {
    max-width: calc(100% - 50px);
    /*no*/
    margin-left: 10px;
    /*no*/
    font-family: Arial;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 40px;
    /*no*/
    letter-spacing: 0em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

li:hover {
    cursor: pointer;
    text-decoration: underline;
    color: blue;
}

#taskMultiSources ul::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: #fff;
    position: absolute;
    z-index: 700;
}

#taskMultiSources ul::-webkit-scrollbar-thumb {
    height: 1Px;
    /*no*/
    border-radius: 5Px;
    /*no*/
    background-color: #becae4;
    position: absolute;
    z-index: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_multi_sources_popup.vue